var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//!!!! WARNING !!!!!!!!
//This is an auto generated file.
//Changes to this code will be lost if the code is regenerated.
//Generated by: TsAppClientApiPrinter
//Contact #dev-ui-platform-support in case of issues
import { GeneratedApiClient } from "../ApiClient";
import { HttpMethod, AuthStrategy } from "../HttpClient";
/* tslint:disable:no-namespace */
export var FleetPortalOrderService;
(function (FleetPortalOrderService) {
    var ApiClientClass = /** @class */ (function (_super) {
        __extends(ApiClientClass, _super);
        function ApiClientClass() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /** Generated from: {@link [FleetDispatchingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetDispatchingController.ts)} */
            _this.getFleetDispatchingConfig = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getFleetDispatchingConfig",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetDispatchingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetDispatchingController.ts)} */
            _this.getScheduledRides = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getScheduledRides",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetDispatchingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetDispatchingController.ts)} */
            _this.assignScheduledRide = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/assignScheduledRide",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetDispatchingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetDispatchingController.ts)} */
            _this.cancelScheduledRide = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/cancelScheduledRide",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetDispatchingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetDispatchingController.ts)} */
            _this.getDriversForScheduledRideAssignment = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDriversForScheduledRideAssignment",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetDispatchingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetDispatchingController.ts)} */
            _this.findRideOptions = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/findRideOptions",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetDispatchingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetDispatchingController.ts)} */
            _this.getDriversForOrderCreationAssignment = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDriversForOrderCreationAssignment",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetDispatchingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetDispatchingController.ts)} */
            _this.createOrder = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/createOrder",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetDispatchingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetDispatchingController.ts)} */
            _this.validateOrderCreationStep = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/validateOrderCreationStep",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [AddressController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/AddressController.ts)} */
            _this.getPickupSuggestions = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getPickupSuggestions",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [AddressController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/AddressController.ts)} */
            _this.getDropoffSuggestions = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDropoffSuggestions",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [AddressController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/AddressController.ts)} */
            _this.getAddressFromPlace = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getAddressFromPlace",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [AddressController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/AddressController.ts)} */
            _this.recordPickupAddressEntered = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/recordPickupAddressEntered",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [AddressController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/AddressController.ts)} */
            _this.recordDropoffAddressEntered = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/recordDropoffAddressEntered",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetAcceptanceController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetAcceptanceController.ts)} */
            _this.getPendingOrdersForFleet = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getPendingOrdersForFleet",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetAcceptanceController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetAcceptanceController.ts)} */
            _this.getRecentlyAcceptedFleetOrders = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getRecentlyAcceptedFleetOrders",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetAcceptanceController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetAcceptanceController.ts)} */
            _this.acceptPendingOrder = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/acceptPendingOrder",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetAcceptanceController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/FleetAcceptanceController.ts)} */
            _this.rejectPendingOrder = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/rejectPendingOrder",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [OrderHistoryController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/OrderHistoryController.ts)} */
            _this.orderHistoryGetTable = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/orderHistory/getTable",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [OrderHistoryController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/controller/OrderHistoryController.ts)} */
            _this.orderHistoryGetCsv = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/orderHistory/getCsv",
                            service_id: "fleet-portal-order",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            return _this;
        }
        return ApiClientClass;
    }(GeneratedApiClient));
    // Split class actual prototype and type
    FleetPortalOrderService.ApiClient = ApiClientClass;
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var Accessibility;
    (function (Accessibility) {
        Accessibility["VISIBLE"] = "visible";
        Accessibility["HIDDEN"] = "hidden";
    })(Accessibility = FleetPortalOrderService.Accessibility || (FleetPortalOrderService.Accessibility = {}));
    /** Generated from: {@link [GeoInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/geo/GeoInternalAsyncApi.ts)} */
    var AddressDetailsLevel;
    (function (AddressDetailsLevel) {
        AddressDetailsLevel["POI"] = "point_of_interest";
        AddressDetailsLevel["STREET_NUMBER"] = "street_number";
        AddressDetailsLevel["STREET"] = "street";
        AddressDetailsLevel["DISTRICT"] = "district";
        AddressDetailsLevel["OTHER"] = "other";
    })(AddressDetailsLevel = FleetPortalOrderService.AddressDetailsLevel || (FleetPortalOrderService.AddressDetailsLevel = {}));
    /** Generated from: {@link [types.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/constants/types.ts)} */
    var AssignmentType;
    (function (AssignmentType) {
        AssignmentType["AUTOMATIC"] = "automatic";
        AssignmentType["MANUAL"] = "manual";
    })(AssignmentType = FleetPortalOrderService.AssignmentType || (FleetPortalOrderService.AssignmentType = {}));
    /** Generated from: {@link [LocationSuggestionsInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/location_suggestions/LocationSuggestionsInternalAsyncApi.ts)} */
    var BoltPlaceType;
    (function (BoltPlaceType) {
        BoltPlaceType["ACCOMMODATION"] = "accommodation";
        BoltPlaceType["AIRPORT"] = "airport";
        BoltPlaceType["EDUCATION"] = "education";
        BoltPlaceType["ENTERTAINMENT"] = "entertainment";
        BoltPlaceType["FINANCE"] = "finance";
        BoltPlaceType["FOOD"] = "food";
        BoltPlaceType["GOVERNMENT"] = "government";
        BoltPlaceType["HEALTH"] = "health";
        BoltPlaceType["INDUSTRY"] = "industry";
        BoltPlaceType["NATURAL"] = "natural";
        BoltPlaceType["NIGHTLIFE"] = "nightlife";
        BoltPlaceType["PARKING"] = "parking";
        BoltPlaceType["RECREATION"] = "recreation";
        BoltPlaceType["RELIGION"] = "religion";
        BoltPlaceType["RETAIL"] = "retail";
        BoltPlaceType["SERVICES"] = "service";
        BoltPlaceType["TRANSPORT"] = "transport";
        BoltPlaceType["BUS_STATION"] = "bus_station";
        BoltPlaceType["TAXI_STATION"] = "taxi_station";
        BoltPlaceType["SUBWAY_STATION"] = "subway_station";
        BoltPlaceType["TRAM_STATION"] = "tram_station";
        BoltPlaceType["TRAIN_STATION"] = "train_station";
        BoltPlaceType["FERRY_TERMINAL"] = "ferry_terminal";
        BoltPlaceType["OTHER"] = "other";
    })(BoltPlaceType = FleetPortalOrderService.BoltPlaceType || (FleetPortalOrderService.BoltPlaceType = {}));
    /** Generated from: {@link [BrandHelper.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/util/brand/BrandHelper.ts)} */
    var BrandEnum;
    (function (BrandEnum) {
        BrandEnum["BOLT"] = "bolt";
        BrandEnum["HOPP"] = "hopp";
    })(BrandEnum = FleetPortalOrderService.BrandEnum || (FleetPortalOrderService.BrandEnum = {}));
    /** Generated from: {@link [types.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/constants/types.ts)} */
    var CreateOrderPaymentMethod;
    (function (CreateOrderPaymentMethod) {
        CreateOrderPaymentMethod["CASH"] = "cash";
        CreateOrderPaymentMethod["CARD_TERMINAL"] = "card_terminal";
    })(CreateOrderPaymentMethod = FleetPortalOrderService.CreateOrderPaymentMethod || (FleetPortalOrderService.CreateOrderPaymentMethod = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var DateType;
    (function (DateType) {
        DateType["DATETIME"] = "datetime";
        DateType["SHORT_DATETIME"] = "short_datetime";
    })(DateType = FleetPortalOrderService.DateType || (FleetPortalOrderService.DateType = {}));
    /** Generated from: {@link [FleetDispatchingConfigService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/service/FleetDispatchingConfigService.ts)} */
    var Enabled;
    (function (Enabled) {
        Enabled["FALSE"] = "false";
        Enabled["TRUE"] = "true";
    })(Enabled = FleetPortalOrderService.Enabled || (FleetPortalOrderService.Enabled = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var EntityState;
    (function (EntityState) {
        EntityState["DEFAULT"] = "default";
        EntityState["INACTIVE"] = "inactive";
        EntityState["ALERT"] = "alert";
        EntityState["SUCCESS"] = "success";
        EntityState["DANGER"] = "danger";
        EntityState["WARNING"] = "warning";
        EntityState["PENDING"] = "pending";
    })(EntityState = FleetPortalOrderService.EntityState || (FleetPortalOrderService.EntityState = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var EnumKey;
    (function (EnumKey) {
        EnumKey["CREATED_BY_FLEET"] = "created_by_fleet";
        EnumKey["CREATED_BY_RIDER"] = "created_by_rider";
        EnumKey["CASH"] = "cash";
        EnumKey["CARD_TERMINAL"] = "card_terminal";
        EnumKey["IN_APP"] = "in_app";
        EnumKey["BUSINESS"] = "business";
    })(EnumKey = FleetPortalOrderService.EnumKey || (FleetPortalOrderService.EnumKey = {}));
    /** Generated from: {@link [GeoInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/geo/GeoInternalAsyncApi.ts)} */
    var GeoOptimisation;
    (function (GeoOptimisation) {
        GeoOptimisation["COST"] = "cost";
        GeoOptimisation["ACCURACY"] = "accuracy";
        GeoOptimisation["LATENCY"] = "latency";
    })(GeoOptimisation = FleetPortalOrderService.GeoOptimisation || (FleetPortalOrderService.GeoOptimisation = {}));
    /** Generated from: {@link [GeoInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/geo/GeoInternalAsyncApi.ts)} */
    var GeoProvider;
    (function (GeoProvider) {
        GeoProvider["GOOGLE"] = "google";
        GeoProvider["MICROSOFT"] = "microsoft";
        GeoProvider["INTERNAL"] = "internal";
        GeoProvider["INTERNAL_BICYCLE"] = "internal_bicycle";
        GeoProvider["INTERNAL_CAR"] = "internal_car";
        GeoProvider["INTERNAL_PEDESTRIAN"] = "internal_pedestrian";
        GeoProvider["INTERNAL_SCOOTER"] = "internal_scooter";
        GeoProvider["INTERNAL_MOTORBIKE"] = "internal_motorbike";
        GeoProvider["TWOGIS"] = "twogis";
        GeoProvider["TOMTOM"] = "tomtom";
        GeoProvider["TOMTOM_ORBIS"] = "tomtom_orbis";
        GeoProvider["CUSTOM_AREA"] = "custom_area";
        GeoProvider["GEO_SPOT"] = "geo_spot";
        GeoProvider["MAPBOX"] = "mapbox";
        GeoProvider["HERE"] = "here";
    })(GeoProvider = FleetPortalOrderService.GeoProvider || (FleetPortalOrderService.GeoProvider = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var ListColumnType;
    (function (ListColumnType) {
        ListColumnType["STRING"] = "string";
        ListColumnType["DURATION"] = "duration";
        ListColumnType["NUMBER"] = "number";
        ListColumnType["REFERENCE_V2"] = "reference_v2";
        ListColumnType["STATE"] = "state";
        ListColumnType["DATE"] = "date";
        ListColumnType["BOOLEAN"] = "boolean";
        ListColumnType["STATUS"] = "status";
        ListColumnType["ENUM"] = "enum";
        ListColumnType["CUSTOM"] = "custom";
    })(ListColumnType = FleetPortalOrderService.ListColumnType || (FleetPortalOrderService.ListColumnType = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var NumberType;
    (function (NumberType) {
        NumberType["INTEGER"] = "integer";
        NumberType["DECIMAL"] = "decimal";
    })(NumberType = FleetPortalOrderService.NumberType || (FleetPortalOrderService.NumberType = {}));
    /** Generated from: {@link [OrderCoreFleetPortalIntegrationsInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/order_core_integrations/OrderCoreFleetPortalIntegrationsInternalAsyncApi.ts)} */
    var OrderApprovalState;
    (function (OrderApprovalState) {
        OrderApprovalState["WAITING_ACCEPTANCE"] = "waiting_acceptance";
        OrderApprovalState["ACCEPTED"] = "order_accepted";
        OrderApprovalState["REJECTED"] = "order_rejected";
        OrderApprovalState["ORDER_TERMINATED"] = "order_terminated";
    })(OrderApprovalState = FleetPortalOrderService.OrderApprovalState || (FleetPortalOrderService.OrderApprovalState = {}));
    /** Generated from: {@link [OrderCreationValidationService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/service/OrderCreationValidationService.ts)} */
    var OrderCreationStep;
    (function (OrderCreationStep) {
        OrderCreationStep["ROUTE_DETAILS"] = "route_details";
        OrderCreationStep["RIDE_DETAILS"] = "ride_details";
        OrderCreationStep["ASSIGNMENT_DETAILS"] = "assignment_details";
    })(OrderCreationStep = FleetPortalOrderService.OrderCreationStep || (FleetPortalOrderService.OrderCreationStep = {}));
    /** Generated from: {@link [types.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/constants/types.ts)} */
    var OrderCreationType;
    (function (OrderCreationType) {
        OrderCreationType["INSTANT"] = "instant";
        OrderCreationType["SCHEDULED"] = "scheduled";
    })(OrderCreationType = FleetPortalOrderService.OrderCreationType || (FleetPortalOrderService.OrderCreationType = {}));
    /** Generated from: {@link [OrderHistoryService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/service/OrderHistoryService.ts)} */
    var OrderHistoryOrderState;
    (function (OrderHistoryOrderState) {
        OrderHistoryOrderState["CLIENT_CANCELLED"] = "client_cancelled";
        OrderHistoryOrderState["DRIVER_DID_NOT_RESPOND"] = "driver_did_not_respond";
        OrderHistoryOrderState["DRIVER_REJECTED"] = "driver_rejected";
        OrderHistoryOrderState["CLIENT_DID_NOT_SHOW"] = "client_did_not_show";
        OrderHistoryOrderState["FINISHED"] = "finished";
        OrderHistoryOrderState["DRIVER_CANCELLED_AFTER_ACCEPT"] = "driver_cancelled_after_accept";
    })(OrderHistoryOrderState = FleetPortalOrderService.OrderHistoryOrderState || (FleetPortalOrderService.OrderHistoryOrderState = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var ReferenceType;
    (function (ReferenceType) {
        ReferenceType["VEHICLE"] = "vehicle";
        ReferenceType["DRIVER"] = "driver";
        ReferenceType["VEHICLE_LISTING_APPLICATION"] = "vehicle_listing_application";
    })(ReferenceType = FleetPortalOrderService.ReferenceType || (FleetPortalOrderService.ReferenceType = {}));
    /** Generated from: {@link [Constants.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_portal_order/main/constants/Constants.ts)} */
    var ResultType;
    (function (ResultType) {
        ResultType["SUCCESS"] = "success";
        ResultType["ERROR"] = "error";
    })(ResultType = FleetPortalOrderService.ResultType || (FleetPortalOrderService.ResultType = {}));
    /** Generated from: {@link [GeoInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/geo/GeoInternalAsyncApi.ts)} */
    var SelectionEventName;
    (function (SelectionEventName) {
        SelectionEventName["GOOGLE_PLACE"] = "Google Places";
        SelectionEventName["GOOGLE_ADDRESS"] = "Google Address";
        SelectionEventName["TWOGIS_PLACE"] = "Twogis Places";
        SelectionEventName["TWOGIS_ADDRESS"] = "Twogis Address";
        SelectionEventName["MICROSOFT_PLACE"] = "Microsoft Places";
        SelectionEventName["MICROSOFT_ADDRESS"] = "Microsoft Address";
        SelectionEventName["TOMTOM_PLACE"] = "TomTom Places";
        SelectionEventName["TOMTOM_ADDRESS"] = "TomTom Address";
        SelectionEventName["TOMTOM_ORBIS_PLACE"] = "TomTomOrbis Places";
        SelectionEventName["TOMTOM_ORBIS_ADDRESS"] = "TomTomOrbis Address";
        SelectionEventName["MAPBOX_PLACE"] = "Mapbox Places";
        SelectionEventName["MAPBOX_ADDRESS"] = "Mapbox Address";
        SelectionEventName["HERE_PLACE"] = "Here Places";
        SelectionEventName["HERE_ADDRESS"] = "Here Address";
        SelectionEventName["INTERNAL_PLACE"] = "Internal Places";
        SelectionEventName["INTERNAL_ADDRESS"] = "Internal Address";
        SelectionEventName["CUSTOM_AREA"] = "Custom Area";
        SelectionEventName["GEO_SPOT"] = "Geo Spot";
    })(SelectionEventName = FleetPortalOrderService.SelectionEventName || (FleetPortalOrderService.SelectionEventName = {}));
    /** Generated from: {@link [LocationSuggestionsInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/location_suggestions/LocationSuggestionsInternalAsyncApi.ts)} */
    var SuggestionImage;
    (function (SuggestionImage) {
        SuggestionImage["HOME"] = "HOME";
        SuggestionImage["WORK"] = "WORK";
        SuggestionImage["HISTORY"] = "HISTORY";
        SuggestionImage["BOLT_DRIVE"] = "BOLT_DRIVE";
        SuggestionImage["CALENDAR"] = "CALENDAR";
        SuggestionImage["DEFAULT"] = "DEFAULT";
        SuggestionImage["HOME_V1"] = "HOME_V1";
        SuggestionImage["WORK_V1"] = "WORK_V1";
        SuggestionImage["HISTORY_V1"] = "HISTORY_V1";
        SuggestionImage["DEFAULT_V1"] = "DEFAULT_V1";
        SuggestionImage["AIRPORT"] = "AIRPORT";
        SuggestionImage["EDUCATION"] = "EDUCATION";
        SuggestionImage["FOOD"] = "FOOD";
        SuggestionImage["GOVERNMENT"] = "GOVERNMENT";
        SuggestionImage["HEALTH"] = "HEALTH";
        SuggestionImage["NATURAL"] = "NATURAL";
        SuggestionImage["NIGHTLIFE"] = "NIGHTLIFE";
        SuggestionImage["RETAIL"] = "RETAIL";
        SuggestionImage["STAR"] = "STAR";
        SuggestionImage["BUSINESS"] = "BUSINESS";
        SuggestionImage["PIN"] = "PIN";
        SuggestionImage["HEART"] = "HEART";
        SuggestionImage["ECO"] = "ECO";
        SuggestionImage["ZOO"] = "ZOO";
        SuggestionImage["GYM"] = "GYM";
        SuggestionImage["SPA"] = "SPA";
        SuggestionImage["STADIUM"] = "STADIUM";
        SuggestionImage["CAMPGROUND"] = "CAMPGROUND";
        SuggestionImage["TOURIST_ATTRACTION"] = "TOURIST_ATTRACTION";
        SuggestionImage["PARKING_SPOT"] = "PARKING_SPOT";
        SuggestionImage["BUILDING"] = "BUILDING";
        SuggestionImage["COMPANY"] = "COMPANY";
        SuggestionImage["BOAT"] = "BOAT";
        SuggestionImage["METRO"] = "METRO";
        SuggestionImage["TRAIN"] = "TRAIN";
        SuggestionImage["BUS"] = "BUS";
        SuggestionImage["VEHICLE"] = "VEHICLE";
        SuggestionImage["GROCERIES"] = "GROCERIES";
        SuggestionImage["STORE"] = "STORE";
        SuggestionImage["CASH"] = "CASH";
        SuggestionImage["CAMERA"] = "CAMERA";
    })(SuggestionImage = FleetPortalOrderService.SuggestionImage || (FleetPortalOrderService.SuggestionImage = {}));
    /** Generated from: {@link [LocationSuggestionsInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/location_suggestions/LocationSuggestionsInternalAsyncApi.ts)} */
    var SuggestionSource;
    (function (SuggestionSource) {
        SuggestionSource["FAVORITE_HOME_SOURCE"] = "home";
        SuggestionSource["FAVORITE_WORK_SOURCE"] = "work";
        SuggestionSource["FAVORITE_CUSTOM_SOURCE"] = "custom";
        SuggestionSource["DELIVERY_LOCATION"] = "delivery_location";
        SuggestionSource["SIMILAR_ORDERS_SOURCE"] = "similar_orders";
        SuggestionSource["LAST_UNFULFILLED_ORDER_SOURCE"] = "last_unfulfilled_order";
        SuggestionSource["HISTORY_SOURCE"] = "history";
        SuggestionSource["DELIVERY_HISTORY_SOURCE"] = "delivery_history";
        SuggestionSource["GOOGLE_API_SOURCE"] = "google";
        SuggestionSource["BOLT_DRIVE_VEHICLE_SOURCE"] = "bolt_drive_vehicle";
        SuggestionSource["MICROSOFT_API_SOURCE"] = "microsoft";
        SuggestionSource["INTERNAL_PROVIDER_SOURCE"] = "internal";
        SuggestionSource["TWOGIS_API_SOURCE"] = "twogis";
        SuggestionSource["TOMTOM_API_SOURCE"] = "tomtom";
        SuggestionSource["TOMTOM_ORBIS_API_SOURCE"] = "tomtom_orbis";
        SuggestionSource["MAPBOX_API_SOURCE"] = "mapbox";
        SuggestionSource["HERE_API_SOURCE"] = "here";
        SuggestionSource["POPULAR_PLACES_SOURCE"] = "popular_places";
        SuggestionSource["CUSTOM_AREAS_SOURCE"] = "custom_areas";
        SuggestionSource["GEO_SPOT_SOURCE"] = "geo_spot_source";
        SuggestionSource["CALENDAR_SOURCE"] = "calendar_source";
    })(SuggestionSource = FleetPortalOrderService.SuggestionSource || (FleetPortalOrderService.SuggestionSource = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var TrendBehavior;
    (function (TrendBehavior) {
        TrendBehavior["POSITIVE_IS_SUCCESS"] = "positive_as_success";
        TrendBehavior["POSITIVE_IS_DANGER"] = "positive_as_danger";
    })(TrendBehavior = FleetPortalOrderService.TrendBehavior || (FleetPortalOrderService.TrendBehavior = {}));
})(FleetPortalOrderService || (FleetPortalOrderService = {}));
